import { DISTANCE_OPTIONS } from '../../domain/filterOptions/constants'
import { isNil } from '../checks'
import isEnglishLanguage from '../isEnglishLanguage'
import { DistanceObject } from '@/types/DistanceOptions'

export const getLocaleDistanceOptions = (): DistanceObject[] => {
  const distanceOptions = isEnglishLanguage()
    ? DISTANCE_OPTIONS.US
    : DISTANCE_OPTIONS.Global

  return distanceOptions
}

export const getLocaleDistanceOptionByIndex = (
  selectedDistanceIndex: number | null | undefined
): DistanceObject => {
  const distanceOptions = getLocaleDistanceOptions()

  if (isNil(selectedDistanceIndex)) {
    return distanceOptions[distanceOptions.length - 1]
  }
  return distanceOptions[selectedDistanceIndex]
}
